import { IFormatsItem } from '../interfaces';

export const findNextFormat = (formatsList: IFormatsItem[], until: number): IFormatsItem =>
    formatsList.find((formatItem) => until >= formatItem.second);
